import { html, ref } from '@microsoft/fast-element';
import type { MoreInfoModal } from './more-info-modal';

export const MoreInfoModalTemplate = html<MoreInfoModal>`
  <centered-modal
    ${ref('moreInfoModal')}
    @modalClosing="${(x) => x.closeMoreInfoModal()}"
    show="${(x) => x.show}"
    allowOverlayClose="true"
    header="${(x) => x.title}"
  >
    ${(x) => x.getContentFromItem()}
  </centered-modal>
`;
